import { Link, getRouteApi } from '@tanstack/react-router'
import type { DirectStore, Organization } from '@/modules/shared/types'

const route = getRouteApi('/select')

/**
 * Presentational chooser for a signed-in user who belongs to more than one
 * unambiguous destination (multiple agencies, or an agency plus direct
 * stores). `orgLandingTarget` only routes here when the destination is
 * genuinely ambiguous — a single membership skips this screen entirely.
 */
export function WorkspaceSelectView({
  organizations,
  stores,
}: {
  organizations: readonly Organization[]
  stores: readonly DirectStore[]
}) {
  return (
    <div className="auth-frame" style={{ display: 'grid', placeItems: 'center' }}>
      <section className="auth-form-panel" style={{ maxWidth: 480 }}>
        <div className="auth-form-wrap">
          <div className="auth-eyebrow">Choose a workspace</div>
          <h1 className="auth-h">Where do you want to work?</h1>
          <p className="auth-sub">Pick an agency or one of your direct stores.</p>

          {organizations.length > 0 && (
            <div className="auth-field">
              <label className="auth-label">Agencies</label>
              {organizations.map((org) => (
                <Link
                  key={org.id}
                  to="/$orgSlug/overview"
                  params={{ orgSlug: org.slug }}
                  className="scc-btn"
                  style={{ display: 'block', marginBottom: 10, textAlign: 'left' }}
                >
                  {org.name}
                </Link>
              ))}
            </div>
          )}

          {stores.length > 0 && (
            <div className="auth-field">
              <label className="auth-label">Your stores</label>
              {stores.map((s) => (
                <Link
                  key={s.id}
                  to="/$orgSlug/$clientSlug"
                  params={{ orgSlug: s.orgSlug, clientSlug: s.slug }}
                  className="scc-btn"
                  style={{ display: 'flex', flexDirection: 'column', marginBottom: 10, textAlign: 'left' }}
                >
                  <span>{s.name}</span>
                  <span className="scc-muted" style={{ fontSize: '0.85em' }}>{s.orgName}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export function WorkspaceSelectPage() {
  const { workspaces, stores } = route.useRouteContext()
  return <WorkspaceSelectView organizations={workspaces.organizations} stores={stores} />
}
